import { apiClient, newIdempotencyKey } from './client'
import type { CursorPage } from './accounts'
import type { LegalEntityView } from '../types/account'

export interface CreateLegalEntityRequest {
  accountId: string
  name: string
  jurisdiction: string
  taxIdentifiers?: Array<Record<string, string>>
  entityGroupId?: string | null
}

export interface ListLegalEntitiesParams {
  filter?: string | null
  sort?: string | null
  cursor?: string | null
  limit?: number
}

function toQuery(params: ListLegalEntitiesParams): string {
  const q = new URLSearchParams()
  if (params.filter) q.set('filter', params.filter)
  if (params.sort) q.set('sort', params.sort)
  if (params.cursor) q.set('cursor', params.cursor)
  q.set('limit', String(params.limit ?? 50))
  return q.toString()
}

export async function listLegalEntities(
  params: ListLegalEntitiesParams,
  signal?: AbortSignal,
): Promise<CursorPage<LegalEntityView>> {
  const { data } = await apiClient.get<CursorPage<LegalEntityView>>(`/legal-entities?${toQuery(params)}`, {
    signal,
  })
  return data
}

export async function getLegalEntity(id: string, signal?: AbortSignal): Promise<{ entity: LegalEntityView; version: number }> {
  const { data, version } = await apiClient.get<LegalEntityView>(`/legal-entities/${id}`, { signal })
  return { entity: data, version: version ?? data.version }
}

export async function createLegalEntity(
  request: CreateLegalEntityRequest,
): Promise<{ entity: LegalEntityView; version: number }> {
  const { data, version } = await apiClient.post<LegalEntityView>('/legal-entities', request, {
    idempotencyKey: newIdempotencyKey(),
  })
  return { entity: data, version: version ?? data.version }
}
